import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import ActiviteitenWidget from "./Activiteiten/Components/widget";
import FaciliteitenWidget from "./Faciliteiten/Components/widget";
import SensorWidget from "./Sensors/Components/widget";
import SensorWidgetFavo from "./Sensors/Components/favowidget";
import VVVItemsWidget from "./Items/Components/widget";
import ErvaringenWidget from "./Ervaringen/Components/widget";
import BoekingenWidget from "./Boekingen/Components/widget";
import ErvaringenWidgetAankomende from "./Ervaringen/Components/widgetaankomende";
import FavSesnorenWidget from "./Standplaatsen/Kampeerplaatsen/favowidgetMeter";
import FavAccoWidget from "./Standplaatsen/Accommodaties/Components/favowidget";
import { fetchsensoren } from "./Sensors/Reducers/actions";
import Loading from "../Components/loading/load";
import bedrijven from "../Components/Lib/Bedrijven/bedrijven";
import MeterInstellen from "./Standplaatsen/Kampeerplaatsen/Components/MeterInstellen";

const Startpage = ({ user, sensoren, fetchsensoren, history }) => {
  const [load, setLoad] = useState(false);
  const [widgets, setWidgets] = useState([]);
  const [editMode, setEditMode] = useState(false);

  const vaild = (vall) => {
    return vall.includes(user.role);
  };

  const ismodule = (val) => {
    return user.bedrijf && user.bedrijf.modules && user.bedrijf.modules.includes(val);
  };

  // Default widget configuration
  const getDefaultWidgets = () => {
    const defaultWidgets = [];
    let index = 0;

    if (vaild(["admin", "manager", "medewerker", "faciliteitmedewerker"]) && ismodule("sensoren") && sensoren.some((sensor) => sensor.favo === true)) {
      defaultWidgets.push({
        id: `widget-${index++}`,
        type: 'sensor-favo',
        title: 'Favoriete sensoren',
        size: 'col-md-12',
        order: defaultWidgets.length,
        visible: true
      });
    }

    if (vaild(["admin", "manager", "medewerker", "faciliteitmedewerker", "havenmeester", "receptie"]) && ismodule("kampeerplaatsen")) {
      defaultWidgets.push({
        id: `widget-${index++}`,
        type: 'kampeerplaatsen',
        title: bedrijven("plaatsen"),
        size: 'col-md-12',
        order: defaultWidgets.length,
        visible: true
      });
    }

    if (vaild(["admin", "manager", "medewerker", "faciliteitmedewerker", "receptie"]) && ismodule("accommodaties")) {
      defaultWidgets.push({
        id: `widget-${index++}`,
        type: 'accommodaties',
        title: 'Accommodaties',
        size: 'col-md-12',
        order: defaultWidgets.length,
        visible: true
      });
    }

    if (vaild(["admin", "manager", "medewerker", "faciliteitmedewerker"]) && ismodule("sensoren")) {
      defaultWidgets.push({
        id: `widget-${index++}`,
        type: 'sensor-list',
        title: 'Lijst sensoren',
        size: 'col-md-12',
        order: defaultWidgets.length,
        visible: true
      });
    }

    if (vaild(["admin", "manager", "hoofdrecreatie", "faciliteitmedewerker"]) && ismodule("activiteiten")) {
      defaultWidgets.push({
        id: `widget-${index++}`,
        type: 'activiteiten',
        title: 'Activiteiten waar je voor in kan schrijven',
        size: 'col-xl-6',
        order: defaultWidgets.length,
        visible: true
      });
    }

    if (vaild(["admin", "manager", "hoofdrecreatie", "faciliteitmedewerker"]) && ismodule("faciliteiten")) {
      defaultWidgets.push({
        id: `widget-${index++}`,
        type: 'faciliteiten',
        title: 'Lijst met Faciliteiten',
        size: 'col-xl-6',
        order: defaultWidgets.length,
        visible: true
      });
    }

    if (vaild(["admin", "manager", "medewerker", "faciliteitmedewerker"]) && ismodule("items")) {
      defaultWidgets.push({
        id: `widget-${index++}`,
        type: 'vvv-items',
        title: 'VVV Items',
        size: 'col-xl-6',
        order: defaultWidgets.length,
        visible: true
      });
    }

    if (vaild(["admin", "manager", "medewerker", "ervaringeigenaar"]) && ismodule("ervaringen")) {
      defaultWidgets.push({
        id: `widget-${index++}`,
        type: 'ervaringen-aankomende',
        title: 'Aankomende ervaringen',
        size: 'col-xl-6',
        order: defaultWidgets.length,
        visible: true
      });
    }

    if (vaild(["admin", "manager", "medewerker", "ervaringeigenaar"]) && ismodule("ervaringen")) {
      defaultWidgets.push({
        id: `widget-${index++}`,
        type: 'boekingen',
        title: 'Overzicht nieuwe boekingen',
        size: 'col-md-12',
        order: defaultWidgets.length,
        visible: true
      });
    }

    if (vaild(["admin", "manager", "medewerker", "ervaringeigenaar"]) && ismodule("ervaringen")) {
      defaultWidgets.push({
        id: `widget-${index++}`,
        type: 'ervaringen',
        title: 'Ervaringen',
        size: 'col-md-12',
        order: defaultWidgets.length,
        visible: true
      });
    }

    if (vaild(["installateur"]) && ismodule("kampeerplaatsen")) {
      defaultWidgets.push({
        id: `widget-${index++}`,
        type: 'meter-instellen',
        title: 'Meter Instellen',
        size: 'col-md-12',
        order: defaultWidgets.length,
        visible: true
      });
    }

    return defaultWidgets;
  };

  // Load widgets from localStorage or use defaults
  useEffect(() => {
    const savedWidgets = localStorage.getItem('dashboard-widgets');
    if (savedWidgets) {
      try {
        const parsedWidgets = JSON.parse(savedWidgets);
        setWidgets(parsedWidgets);
      } catch (error) {
        console.error('Error parsing saved widgets:', error);
        setWidgets(getDefaultWidgets());
      }
    } else {
      setWidgets(getDefaultWidgets());
    }
  }, [sensoren, user]); // Re-run when sensoren or user changes

  useEffect(() => {
    fetchsensoren().then(() => {
      setLoad(true);
    });
  }, [fetchsensoren]);

  // Save widgets to localStorage
  const saveWidgets = (updatedWidgets) => {
    localStorage.setItem('dashboard-widgets', JSON.stringify(updatedWidgets));
    setWidgets(updatedWidgets);
  };

  // Handle drag end for settings panel
  const handleSettingsDragEnd = (result) => {
    if (!result.destination) return;

    const sortedWidgets = [...widgets].sort((a, b) => a.order - b.order);
    const [reorderedItem] = sortedWidgets.splice(result.source.index, 1);
    sortedWidgets.splice(result.destination.index, 0, reorderedItem);

    // Update order property
    const reorderedWidgets = sortedWidgets.map((widget, index) => ({
      ...widget,
      order: index
    }));

    saveWidgets(reorderedWidgets);
  };

  // Toggle widget size
  const toggleWidgetSize = (widgetId) => {
    const updatedWidgets = widgets.map(widget => {
      if (widget.id === widgetId) {
        const newSize = widget.size === 'col-md-12' ? 'col-xl-6' : 'col-md-12';
        return { ...widget, size: newSize };
      }
      return widget;
    });
    saveWidgets(updatedWidgets);
  };

  // Toggle widget visibility
  const toggleWidgetVisibility = (widgetId) => {
    const updatedWidgets = widgets.map(widget => {
      if (widget.id === widgetId) {
        return { ...widget, visible: !widget.visible };
      }
      return widget;
    });
    saveWidgets(updatedWidgets);
  };

  // Reset to default layout
  const resetLayout = () => {
    if (window.confirm('Wilt u het dashboard terugzetten naar de standaard layout?')) {
      const defaultWidgets = getDefaultWidgets();
      saveWidgets(defaultWidgets);
    }
  };

  // Render widget content based on type
  const renderWidgetContent = (widget) => {
    switch (widget.type) {
      case 'sensor-favo':
        return load && <SensorWidgetFavo sensoren={sensoren} />;
      case 'kampeerplaatsen':
        return load && <FavSesnorenWidget sensoren={sensoren} />;
      case 'accommodaties':
        return load && <FavAccoWidget sensoren={sensoren} />;
      case 'sensor-list':
        return load && <SensorWidget sensoren={sensoren} />;
      case 'activiteiten':
        return <ActiviteitenWidget />;
      case 'faciliteiten':
        return <FaciliteitenWidget />;
      case 'vvv-items':
        return <VVVItemsWidget history={history} />;
      case 'ervaringen-aankomende':
        return <ErvaringenWidgetAankomende />;
      case 'boekingen':
        return <BoekingenWidget />;
      case 'ervaringen':
        return <ErvaringenWidget />;
      case 'meter-instellen':
        return <MeterInstellen />;
      default:
        return null;
    }
  };

  // Filter and sort widgets
  const visibleWidgets = widgets
    .filter(widget => widget.visible)
    .sort((a, b) => a.order - b.order);

  return (
    <>
      {/* Dashboard Controls */}
      <div className="row mb-3">
        <div className="col-12">
          <div className="card">
            <div className="card-body py-2">
              <div className="d-flex justify-content-between align-items-center">
                <h6 className="mb-0">
                  <i className="bx bx-dashboard me-2"></i>Dashboard
                </h6>
                <div className="d-flex gap-2">
                  <button 
                    className={`btn btn-sm ${editMode ? 'btn-success' : 'btn-outline-primary'}`}
                    onClick={() => setEditMode(!editMode)}
                  >
                    <i className={`bx ${editMode ? 'bx-check' : 'bx-edit'} me-1`}></i>
                    {editMode ? 'Klaar' : 'Bewerken'}
                  </button>
                  {editMode && (
                    <button 
                      className="btn btn-sm btn-outline-secondary"
                      onClick={resetLayout}
                    >
                      <i className="bx bx-reset me-1"></i>Reset
                    </button>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Widget Configuration Panel */}
      {editMode && (
        <div className="row mb-3">
          <div className="col-12">
            <div className="card">
              <div className="card-header">
                <h6 className="card-title mb-0">Widget Instellingen</h6>
              </div>
              <div className="card-body">
                <DragDropContext onDragEnd={handleSettingsDragEnd}>
                  <Droppable droppableId="widget-settings" direction="vertical">
                    {(provided, snapshot) => (
                      <div
                        {...provided.droppableProps}
                        ref={provided.innerRef}
                        className="row g-2"
                        style={{
                          backgroundColor: snapshot.isDraggingOver ? '#f8f9fa' : 'transparent',
                          borderRadius: '8px',
                          padding: snapshot.isDraggingOver ? '10px' : '0',
                          border: snapshot.isDraggingOver ? '2px dashed #dee2e6' : 'none'
                        }}
                      >
                        {widgets
                          .sort((a, b) => a.order - b.order)
                          .map((widget, index) => (
                          <Draggable key={widget.id} draggableId={widget.id} index={index}>
                            {(provided, snapshot) => (
                              <div 
                                ref={provided.innerRef}
                                {...provided.draggableProps}
                                className="col-md-6"
                                style={{
                                  ...provided.draggableProps.style,
                                  opacity: snapshot.isDragging ? 0.8 : 1
                                }}
                              >
                                <div className={`border rounded p-3 ${widget.visible ? 'bg-light' : 'bg-light-secondary'} ${snapshot.isDragging ? 'shadow' : ''}`}>
                                  <div className="d-flex justify-content-between align-items-center mb-2">
                                    <div className="d-flex align-items-center gap-2">
                                      <div {...provided.dragHandleProps} className="drag-handle" title="Sleep om te herordenen">
                                        <i className="bx bx-grid-vertical"></i>
                                      </div>
                                      <span className="badge bg-secondary">{index + 1}</span>
                                      <small className="fw-semibold">{widget.title}</small>
                                    </div>
                                    <div className="form-check form-switch">
                                      <input
                                        className="form-check-input"
                                        type="checkbox"
                                        checked={widget.visible}
                                        onChange={() => toggleWidgetVisibility(widget.id)}
                                      />
                                    </div>
                                  </div>
                                  {widget.visible && (
                                    <div className="d-flex gap-1">
                                      <button
                                        className={`btn btn-xs ${widget.size === 'col-md-12' ? 'btn-primary' : 'btn-outline-primary'}`}
                                        onClick={() => toggleWidgetSize(widget.id)}
                                      >
                                        Groot
                                      </button>
                                      <button
                                        className={`btn btn-xs ${widget.size === 'col-xl-6' ? 'btn-primary' : 'btn-outline-primary'}`}
                                        onClick={() => toggleWidgetSize(widget.id)}
                                      >
                                        Klein
                                      </button>
                                    </div>
                                  )}
                                </div>
                              </div>
                            )}
                          </Draggable>
                        ))}
                        {provided.placeholder}
                      </div>
                    )}
                  </Droppable>
                </DragDropContext>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Widgets */}
      <div className="row">
        {visibleWidgets.map((widget) => (
          <div key={widget.id} className={widget.size}>
            <div className={`box ${getBoxClass(widget.type)} mb-3`}>
              <div className="box-header with-border">
                <h3 className="box-title">{widget.title}</h3>
              </div>
              <div className="box-body">
                {renderWidgetContent(widget)}
                <Loading loadings={load} />
              </div>
            </div>
          </div>
        ))}
        
        {visibleWidgets.length === 0 && (
          <div className="col-12 text-center py-5">
            <div className="card">
              <div className="card-body">
                <div className="text-muted">
                  <i className="bx bx-ghost bx-lg mb-3"></i>
                  <p>Geen widgets zichtbaar. Activeer widgets in de instellingen hierboven.</p>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>

      {/* Custom CSS */}
      <style jsx>{`
        .btn-xs {
          padding: 0.125rem 0.25rem;
          font-size: 0.75rem;
        }
        .drag-handle {
          cursor: grab;
          padding: 6px;
          border-radius: 4px;
          background-color: rgba(108, 117, 125, 0.1);
          border: 1px solid rgba(108, 117, 125, 0.2);
          transition: all 0.2s ease;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          min-width: 24px;
          height: 24px;
        }
        .drag-handle i {
          color: #6c757d;
          font-size: 14px;
        }
        .drag-handle:hover {
          background-color: rgba(108, 117, 125, 0.2);
          border-color: rgba(108, 117, 125, 0.4);
        }
        .drag-handle:hover i {
          color: #495057;
        }
        .drag-handle:active {
          cursor: grabbing;
          background-color: rgba(108, 117, 125, 0.3);
        }
      `}</style>
    </>
  );
};

// Helper function to get box class based on widget type
const getBoxClass = (type) => {
  switch (type) {
    case 'activiteiten':
      return 'box-success';
    case 'sensor-favo':
    case 'kampeerplaatsen':
    case 'accommodaties':
    case 'sensor-list':
    case 'faciliteiten':
    case 'vvv-items':
    case 'ervaringen-aankomende':
    case 'boekingen':
    case 'ervaringen':
    case 'meter-instellen':
      return 'box-info';
    default:
      return 'box-info';
  }
};

function mapStateToProps(state) {
  return { user: state.auth.user, sensoren: state.sensoren.items };
}

export default connect(mapStateToProps, { fetchsensoren })(Startpage);